module.exports = __webpack_public_path__ + "static/img/money-03.27e25be.png";